The latency of the HTTP request in milliseconds.

This will be `null` if the request wasn't made (i.e. an `InvalidUrl` error occurred).
